import { render, staticRenderFns } from "./BillItem.vue?vue&type=template&id=2b3e1935&"
import script from "./BillItem.vue?vue&type=script&lang=js&"
export * from "./BillItem.vue?vue&type=script&lang=js&"
import style0 from "./BillItem.vue?vue&type=style&index=0&id=2b3e1935&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports